import React from 'react';

import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import TaxRelated from './TaxRelated';

import { useField } from 'app-components/flux/categories/categoryFormHooks';
import TaxFormPersonal from './TaxFormPersonal';
import TaxLineItemPersonal from './TaxLineItemPersonal';
import useStyles from './styles';

const TaxInfoSimplifi = () => {
  const { classes } = useStyles();
  // FUTURE USE - https://quickenteam.atlassian.net/browse/SIMPL-22893
  const hasDefaultTaxAssn = false;
  const isDefaultTaxAssn = false;

  const { value: categoryId } = useField('id');
  const { value: taxRelated } = useField('taxRelated');

  return (
    <Card className={classes.card} sx={{ mt: 3 }}>
      <Stack justifyContent='space-between' flex={1}>
        <Typography variant='bodyMedium'>Tax info</Typography>
        {categoryId &&
          taxRelated &&
          hasDefaultTaxAssn &&
          (isDefaultTaxAssn ? (
            <Typography variant='paragraphRegular'>
              Set by default for your Tax Report. You can change the settings below.
            </Typography>
          ) : (
            <Stack direction='row' alignItems='center'>
              <Typography variant='paragraphRegular'>
                You changed the default tax association for this category.
              </Typography>
              <Typography
                variant='button'
                id='reset-category-tax-info'
                className={classes.resetBtn}
                onClick={() => {
                  alert('Reset button was pressed');
                }}
              >
                Reset
              </Typography>
            </Stack>
          ))}

        <Stack
          direction='row'
          sx={{
            mt: 2,
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Card className={classes.cardControl}>
            <Typography variant='paragraphRegular' lineHeight={2.5}>
              Tax Related
            </Typography>
            <Card>
              <TaxRelated />
            </Card>
          </Card>
        </Stack>
      </Stack>

      {taxRelated && (
        <Stack direction='column' mt={3} spacing={3}>
          <Stack direction='column' spacing={3}>
            <TaxFormPersonal />
            <TaxLineItemPersonal />
          </Stack>
        </Stack>
      )}
    </Card>
  );
};

export default TaxInfoSimplifi;
